export const TRACKING_EVENTS = {
  // Page views
  PAGE_VIEW: 'page_view',
  QUIZ_STARTED: 'quiz_started',
  QUIZ_COMPLETED: 'quiz_completed',
  QUIZ_ABANDONED: 'quiz_abandoned',

  // Interactions
  BUTTON_CLICK: 'button_click',
  QUESTION_ANSWERED: 'question_answered',
  PAGE_VIEWED: 'page_viewed',

  // Facebook Pixel events
  FB_PAGE_VIEW: 'fb_PageView',
  FB_VIEW_CONTENT: 'fb_ViewContent',
  FB_LEAD: 'fb_Lead',
  FB_CUSTOM_QUIZ_START: 'fb_CustomQuizStart',
  FB_CUSTOM_QUIZ_COMPLETE: 'fb_CustomQuizComplete',
  FB_CUSTOM_QUIZ_ABANDONED: 'fb_CustomQuizAbandoned',
} as const;
